import React, { useState } from 'react'
import { Layout as AntLayout } from 'antd'
import LeftSider from './LeftSider'
import Header from './Header'
import styled from 'styled-components'
import { LayoutProps } from 'antd/lib/layout'
import dayjs from 'dayjs'

const { Content, Footer } = AntLayout

interface StyledLayoutPops extends LayoutProps {
  $collapsed: boolean
}

const StyledLayout: React.FC<StyledLayoutPops> = styled((props: StyledLayoutPops) => <AntLayout {...props} />)`
  margin-left: ${(props) => (props.$collapsed ? '0px' : '200px')};
`

const Layout: React.FC<LayoutProps> = ({ children }) => {
  const [collapsed, setCollapsed] = useState(false)

  return (
    <AntLayout style={{ minHeight: '100vh' }}>
      <StyledLayout $collapsed={collapsed}>
        <Content style={{ margin: '50px 0px 0', padding: '10px', height: '100%' }}>{children}</Content>
        <Header collapsed={collapsed} />
        <Footer style={{ textAlign: 'center', padding: 0 }}>D4Immobilier ©{dayjs().format('YYYY')}</Footer>
      </StyledLayout>
      <LeftSider collapsed={collapsed} onCollapse={setCollapsed} />
    </AntLayout>
  )
}

export default Layout
